import { InputNumber } from 'antd';
import React from 'react';

import './PlanPage.css'

export interface IProps {
  label: string | React.ReactNode;
  inputPrefix?: string;
  value?: number;
}

/**
 * Renders a label and numerical input field for a plan property that is a number.
 * This includes both prices and general integers like "included emails".
 */
const NumericalPlanProperty: React.FC<IProps> = (props) => {
  const prefix = props.inputPrefix ? props.inputPrefix + ' ' : '';
  return <div className={'numerical-plan-property'}>
    <label>{props.label}</label>
    {/* setting read-only until we implement edit functionality on this page */}
    <div>{prefix}<InputNumber value={props.value} disabled={true} /></div>
  </div>;
};

export default NumericalPlanProperty;
